import {
  FETCH_SAVED_SEARCHES_SUCCESS,
  CREATE_SAVED_SEARCH_SUCCESS,
  UPDATE_SAVED_SEARCH_SUCCESS,
  DELETE_SAVED_SEARCH_SUCCESS,
} from '../constants/actionTypes'

const initialState = {
  items: [],
  isLoading: false,
  error: null,
}

export default function savedSearchesReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SAVED_SEARCHES_SUCCESS:
      return {
        ...state,
        items: action.payload,
        isLoading: false,
      }
    case CREATE_SAVED_SEARCH_SUCCESS:
      return {
        ...state,
        items: [...state.items, action.payload],
      }
    case UPDATE_SAVED_SEARCH_SUCCESS:
      return {
        ...state,
        items: state.items.map(search =>
          search.saved_search_id === action.payload.saved_search_id
            ? action.payload
            : search
        ),
      }
    case DELETE_SAVED_SEARCH_SUCCESS:
      return {
        ...state,
        items: state.items.filter(
          search => search.saved_search_id !== action.payload
        ),
      }
    default:
      return state
  }
}
